<template>
  <van-calendar
    title="开始时间"
    :min-date="minDate"
    :max-date="maxDate"
    color="#2877FF"
    v-model="showOpen"
    type="range"
    @close="$emit('close')"
    :max-range="availableDate"
    @confirm="confirm"
    :allow-same-day="true"
    ref="VanCalendarRef"
  />
</template>

<script>
import dayjs from "moment";
export default {
  props: {
    value: { type: Array, default: () => [] },
    availableDate: {
      type: Number,
      default: 90,
      validator: value => value >= 0
    },
    show: { type: Boolean, default: false }
  },
  computed: {},
  watch: {
    show(newV) {
      this.showOpen = newV;
    },
    value: {
      handler(newVal) {
        this.$refs.VanCalendarRef.reset(newVal);
      }
    }
  },
  mounted() {
    // 初始设置时间要在mounted,不然reset字段还没有创建,会报错
    this.$refs.VanCalendarRef.reset(this.$props.value);
  },
  data() {
    const {
      yearEnd,
      yearStart,
      monthEnd,
      dayEnd,
      monthStart,
      dayStart
    } = this.setRadiosDateInterval(this.$props.availableDate); //近90天
    return {
      showOpen: false,
      loading: true,
      minDate: new Date(
        Number(yearStart),
        Number(monthStart) - 1,
        Number(dayStart)
      ),
      maxDate: new Date(Number(yearEnd), Number(monthEnd) - 1, Number(dayEnd))
    };
  },

  methods: {
    setRadiosDateInterval(day = 1) {
      const dayNum = 1;
      const splitKey = "-";
      const defaultEndDate = dayjs()
          .subtract(dayNum, "days")
          .format(`YYYY${splitKey}MM${splitKey}DD`);
      const defaultStartDate = dayjs(defaultEndDate)
          .subtract(day - dayNum, "days")
          .format(`YYYY${splitKey}MM${splitKey}DD`); //默认30天
      const [yearEnd, monthEnd, dayEnd] = defaultEndDate.split(splitKey);
      const [yearStart, monthStart, dayStart] = defaultStartDate.split(
          splitKey
      );
      return {
        yearEnd, monthEnd, dayEnd,
        yearStart, monthStart, dayStart,
        allDate: [yearStart + monthStart + dayStart,
          yearEnd + monthEnd + dayEnd]
      }

    },
    confirm(date) {
      this.$emit("onConfirm", date);
    }
  }
};
</script>

<style>
</style>